import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AvailableWidgets, hiddenCategories, hiddenWidgets, WidgetConfigRow, } from '../../../../setting/models/AvailableWidgets';
import { CompanyService } from '../../../../setting/services/company.service';
import { TableSettingsEntity } from '../table-settings/table-settings.component';

@Component({
    selector: 'app-table-settings-modal',
    templateUrl: './table-settings-modal.component.html',
    styleUrls: ['./table-settings-modal.component.css']
})
export class TableSettingsModalComponent implements OnInit, OnDestroy {
    public entity: TableSettingsEntity;
    public availableWidgets$: Observable<AvailableWidgets>;
    public readonly hiddenCategories = hiddenCategories;
    public readonly hiddenWidgets = hiddenWidgets;
    public refreshFn = new EventEmitter<string>();
    public dashboardWidgetsForm: AvailableWidgets['dashboard']['widgets_config'];

    private _availableWidgetsSubscription: Subscription;

    public constructor(
        public activeModal: NgbActiveModal,
        private _companyService: CompanyService,
    ) { }

    public ngOnInit(): void {
        this.availableWidgets$ = this._companyService.availableWidgets$
            .pipe(tap(availableWidgets => this.dashboardWidgetsForm = availableWidgets.dashboard.widgets_config));
    }

    public ngOnDestroy(): void {
        this._availableWidgetsSubscription?.unsubscribe();
    }

    public changeWidgets(type: string, category: string, subKey: string, event: any): void {
        const body = {
            key: `${type}.${category}.${subKey}`,
            value: event.target.checked
        };

        this._companyService.updateAvailableWidget(body)
            .then((result: { message: string, available_widgets: AvailableWidgets }) => {
                this.refreshFn.emit('refetch');
                this._companyService.updateAvailableWidgetsValue(result.available_widgets);
            });
    }

    public onSubmitDashboardOrder(): void {
        this._companyService.updateAvailableWidgetsOrder(this.dashboardWidgetsForm)
            .then((result: { message: string, available_widgets: AvailableWidgets }) => {
                this._companyService.updateAvailableWidgetsValue(result.available_widgets);
            });
    }

    // dashboard order config methods
    public moveUp(widget: WidgetConfigRow): void {
        const previousWidget = this.dashboardWidgetsForm.find(w => w.order === widget.order - 1);
        if (previousWidget.disabled) {
            return;
        }

        const newWidgetsForm = [
            ...this.dashboardWidgetsForm,
        ];

        newWidgetsForm[previousWidget.order] = {...widget, order: widget.order - 1};
        newWidgetsForm[widget.order] = {...previousWidget, order: widget.order};

        this.dashboardWidgetsForm = [...newWidgetsForm];

        this.onSubmitDashboardOrder();
    }

    public moveDown(widget: WidgetConfigRow): void {
        const nextWidget = this.dashboardWidgetsForm.find(w => w.order === widget.order + 1);
        if (!nextWidget) {
            return;
        }

        const newWidgetsForm = [
            ...this.dashboardWidgetsForm,
        ];

        newWidgetsForm[nextWidget.order] = {...widget, order: widget.order + 1};
        newWidgetsForm[widget.order] = {...nextWidget, order: widget.order};
        this.dashboardWidgetsForm = [...newWidgetsForm];

        this.onSubmitDashboardOrder();
    }

    public onShowChange($event: any, widget: WidgetConfigRow): void {
        const index = this.dashboardWidgetsForm.indexOf(widget);
        const newWidgetsForm = [
            ...this.dashboardWidgetsForm,
        ];

        newWidgetsForm[index] = {...widget, show: !widget.show};
        this.dashboardWidgetsForm = [...newWidgetsForm];

        this.onSubmitDashboardOrder();
    }
}
